import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import SocketEngine from "../../core/SocketEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";

class AppointmentBookingList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      merchants: [],
      branches: [],
      appointments: [],
      selectedMerchant: "",
      selectedBranch: "",
      selectedAppointment: "",
      canWrite: false,
    };
    this.engine = new RequestEngine();
  }
  componentDidMount() {
    const merchantIdFromStorage = sessionStorage.getItem("merchantId");

    if (merchantIdFromStorage) {
      this.setState({ selectedMerchant: merchantIdFromStorage }, () => {
        this.fetchbranches();
        const { selectedBranch, selectedAppointment } =
          this.props.location.state || this.props.match.params;
        if (selectedBranch) {
          this.setState({ selectedBranch }, () => this.fetchAppointments());
          if (selectedAppointment) {
            this.setState({ selectedAppointment }, () => {
              this.callPage();
            });
          }
        }
      });
    } else {
      this.fetchmerchants();
    }

    const canWrite = this.hasPermission([
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_WRITE,
    ]);
    this.setState({ canWrite });

    SocketEngine.on("booking:updated", this.handleBookingUpdated);
  }

  componentWillUnmount() {
    SocketEngine.off("booking:updated", this.handleBookingUpdated);
  }

  // Live update: a booking changed somewhere (client action, another garage
  // screen, a worker app) — refresh the list if it's for the branch we're
  // currently looking at.
  handleBookingUpdated = (payload) => {
    if (!this.state.selectedAppointment) return;
    if (payload?.branchId && payload.branchId !== this.state.selectedBranch) {
      return;
    }
    this.callPage();
  };

  fetchmerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
      if (this.state.merchants.length === 1) {
        this.setState({
          selectedMerchant: this.state.merchants[0].value,
        });
        this.fetchbranches();
      }
    }
  };

  fetchbranches = async () => {
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) return;
    const response = await this.engine.getItem(
      `merchants/${selectedMerchant}/branches`
    );
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        branches: response.data.items.map((branch) => ({
          value: branch.id,
          label: branch.name || branch.address,
        })),
        appointments: [],
        dataSource: [],
      });
    }
  };

  fetchAppointments = async () => {
    const { selectedBranch } = this.state;
    if (!selectedBranch) return;

    const response = await this.engine.getItem(
      `merchants-branches/${selectedBranch}/appointments`
    );
    if (response && response.status === 200) {
      this.setState({
        appointments: response.data.items.map((appointment) => ({
          value: appointment.id,
          label: `${appointment.date} ${appointment.fromToHours}`, // Customize label as needed
        })),
      });
    }
  };

  callPage = async () => {
    const { selectedAppointment } = this.state;
    if (!selectedAppointment) return;

    const response = await this.engine.getItem(
      `merchants-branches/${selectedAppointment}/appointment-booking`
    );
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          customer: item.customer.user.firstName,
          customerVehicle: item.customerVehicle.model.name,
          status: item.status,
          reason: item.statusReason,
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }
    this.props.loadingAction(false);
  };

  handlePage = () => {
    this.props.loadingAction(true);
    this.callPage();
  };

  handleMerchantSelect = (event) => {
    const selectedMerchant = event.value;
    this.setState(
      {
        selectedMerchant,
        selectedBranch: "",
        branches: [],
        dataSource: [],
        appointments: [],
      },
      () => {
        this.fetchbranches();
      }
    );
  };
  handlemerchantselect(event) {
    const selectedMerchant = event.value;

    if (selectedMerchant !== this.state.selectedMerchant)
      this.setState(
        { selectedMerchant, selectedBranch: "", branches: [], dataSource: [] },
        () => {
          this.fetchbranches(); // Fetch branches for the selected merchant
        }
      );
  }

  handleBranchSelect = (event) => {
    const selectedBranch = event.value;
    this.setState(
      {
        selectedBranch,
        appointments: [],
        selectedAppointment: "",
        dataSource: [],
      },
      () => {
        this.fetchAppointments();
      }
    );
  };

  handleAppointmentSelect = (event) => {
    const selectedAppointment = event.value;
    this.setState({ selectedAppointment }, () => {
      this.props.history.push(
        `/admin/merchants-branches/${selectedAppointment}/appointment-booking`
      );
      this.callPage(); // Fetch services for the selected branch
    });
  };

  handleAdd = () => {
    const { selectedMerchant, selectedBranch, selectedAppointment } =
      this.state;

    if (!selectedMerchant) {
      alert(strings.select + " " + strings.merchant);
      return;
    }

    if (!selectedBranch) {
      alert(strings.select + " " + strings.branch);
      return;
    }

    if (!selectedAppointment) {
      alert(strings.select + " " + strings.appointment);
      return;
    }

    // Push the selectedMerchant and selectedBranch to the history
    this.props.history.push({
      pathname: `/admin/merchants-branches/${selectedAppointment}/appointment-booking/add`,
      state: { selectedMerchant, selectedBranch, selectedAppointment },
    });
  };

  handleEdit = (index, dataid) => {
    const data = this.state.dataSource[index].data;
    const { selectedMerchant, selectedBranch, selectedAppointment } =
      this.state;

    if (!selectedAppointment) {
      alert(strings.select + " " + strings.appointment);
      return;
    }

    // Push the selectedMerchant and selectedBranch along with the data to the history
    this.props.history.push({
      pathname: `/admin/merchants-branches/${selectedAppointment}/appointment-booking/edit/${dataid}`,
      state: { selectedMerchant, selectedBranch, selectedAppointment },
      data,
    });
  };

  async handleDelete(valueid) {
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const { selectedAppointment } = this.state;
      const result = await this.engine.deleteItem(
        `merchants-branches/${selectedAppointment}/appointment-booking`,
        valueid
      );
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "accepted", label: "Accepted" },
    { value: "rejected", label: "Rejected" },
    { value: "started", label: "Started" },
    { value: "finished", label: "Finished" },
  ];

  handleStatusChange = async (item, newStatus) => {
    const { selectedAppointment } = this.state;
    try {
      await this.engine.updateItem(
        `merchants-branches/${selectedAppointment}/appointment-booking`,
        item.id,
        { version: item.version, status: newStatus }
      );
      this.callPage();
    } catch (err) {
      alert("Failed to update status");
    }
  };

  handleActions = (index, item) => {
    return (
      <RowActions
        actions={[
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  };

  render() {
    const {
      dataSource,
      isLoading,
      merchants,
      branches,
      appointments,
      selectedMerchant,
      selectedBranch,
      selectedAppointment,
      canWrite,
    } = this.state;

    let columns = [
      { Header: strings.customer, accessor: "customer" },
      { Header: strings.customervehicle, accessor: "customerVehicle" },
      {
        Header: strings.status,
        accessor: "status",
        sortable: false,
        filterable: false,
        Cell: (row) => (
          <select
            value={row.original.data.status || ""}
            disabled={!canWrite}
            onChange={(e) =>
              this.handleStatusChange(row.original.data, e.target.value)
            }
            style={{ width: "100%", padding: "4px", borderRadius: "4px" }}
          >
            {this.statusOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ),
      },
      { Header: strings.statusreason, accessor: "reason" },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="pull-left"></CardTitle>
                {canWrite && (
                  <Button
                    color="primary"
                    className="pull-right"
                    onClick={this.handleAdd}
                  >
                    {strings.add}
                  </Button>
                )}
                {!sessionStorage.getItem("merchantId") &&
                  merchants.length !== 1 && (
                    <SelectRow
                      label={strings.merchant}
                      name="selectedMerchant"
                      defaultValue={selectedMerchant}
                      data={merchants}
                      changeInput={this.handleMerchantSelect}
                      placeholder={strings.select}
                    />
                  )}
                <SelectRow
                  key={selectedMerchant || strings.branch}
                  label={strings.branch}
                  name="selectedBranch"
                  defaultValue={selectedBranch}
                  data={branches}
                  changeInput={this.handleBranchSelect}
                  placeholder={strings.select}
                  viewonly={!selectedMerchant}
                />
                <SelectRow
                  key={selectedBranch || strings.appointment}
                  label={strings.appointment}
                  name="selectedAppointment"
                  defaultValue={selectedAppointment}
                  data={appointments}
                  changeInput={this.handleAppointmentSelect}
                  placeholder={strings.select}
                  viewonly={!selectedBranch}
                />
              </CardHeader>
              <CardBody>
                <ReactTable
                  previousText={strings.previous}
                  nextText={strings.next}
                  loadingText={strings.loading}
                  noDataText={strings.nodata}
                  pageText={strings.page}
                  data={dataSource}
                  defaultFilterMethod={this.filterCaseInsensitive}
                  filterable
                  loading={isLoading}
                  columns={columns}
                  defaultPageSize={10}
                  showPaginationTop={false}
                  showPaginationBottom
                  PaginationComponent={TablePagination}
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});

export default connect(null, mapDispatchToProps)(AppointmentBookingList);
